import { Component } from '@angular/core';

@Component({
  selector: 'app-ns-spinner',
  templateUrl: './ns-spinner.component.html',
  styleUrls: ['./ns-spinner.component.scss'],
})
export class NsSpinnerComponent {}
